// extracted by mini-css-extract-plugin
export var button = "_bm-0";
export var icon = "_bm-1";